import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import useAppUser from 'hooks/useAppUser';
import { Property } from 'models/Properties';
import {
  propertyAnalyticsConditionGraphQLQuery,
  propertyAnalyticsGraphQLQuery,
} from 'pages/analyticsAndHostQuality/analytics/Analytics.utils';

const useFetchAllPropertiesForPromoCodes = () => {
  const { agencyUid } = useAppUser();

  const { allProperties: properties, isFetching: isPropertiesLoading } =
    useFetchAllProperties({
      enabled: !!agencyUid,
      conditions: propertyAnalyticsConditionGraphQLQuery,
      fields: propertyAnalyticsGraphQLQuery,
      operationName: 'PropertiesForPromoCodes',
    });

  const propertyMap = properties?.reduce((acc, property) => {
    acc[property.uid] = property;
    return acc;
  }, {} as Record<string, Property>);

  return { properties, isPropertiesLoading, propertyMap };
};

export default useFetchAllPropertiesForPromoCodes;
